import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";
import ErrorsNce from "./pages/estratificacao-defeitos";
import Menu from "./ui/components/Menu/homeHeader";
import Nce from "./pages/nce/nce";
import ComparePage from "./pages/comparativo/comparativo";
import Analitico from "./pages/analitic/analitico";
import PQMFMensal from "./pages/mensal/mensal";
import RankingPage from "./pages/ranking/ranking";
import { useAuth } from "./context/auth";
import AlterarSenha from "./pages/alterar-senha/alterar-senha";
import AdminCarga from "./pages/admin/admin-carga-dados";
import AdminEmbalagens from "./pages/admin/AdminEmbalagens";
import AdminDefeitos from "./pages/admin/AdminDefeitos";
import AdminFeriados from "./pages/admin/AdminFeriados";
import AdminTipoEmbalagens from "./pages/admin/AdminTipoEmbalagem";
import AdminUsuarios from "./pages/admin/AdminUsuarios";
import AdminProdutos from "./pages/admin/AdminProdutos";
import AdminFornecedores from "./pages/admin/AdminFornecedores";
import ProtectedAdminRoute from "./components/routes/ProtectedAdminRoute";
import AdminDashboard from "./pages/admin/Dashboard/AdminDashboard";
import RelatoriosAcesso from "./pages/admin/Dashboard/RelatoriosAcesso";

const RoutesConfig = () => {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Menu>
        <div style={{ marginTop: 50 }}>
          <Routes>
            <Route path="/home" element={<Home />} /> 
          </Routes>
          <Routes>
            <Route path="/alterar-senha" element={<AlterarSenha />} />
          </Routes>
          <Routes>
            <Route path="/admin-users" element={<AdminUsuarios />} />
          </Routes>
          <Routes>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
          </Routes>
          <Routes>
            <Route path="/admin-product" element={<ProtectedAdminRoute> <AdminProdutos /> </ProtectedAdminRoute>} />
          </Routes>
          <Routes>
            <Route path="/admin-feriado" element={<ProtectedAdminRoute> <AdminFeriados /> </ProtectedAdminRoute>} />
          </Routes>
          <Routes>
            <Route path="/admin-suppliers" element={<ProtectedAdminRoute> <AdminFornecedores /> </ProtectedAdminRoute>} />
          </Routes>
          <Routes>
            <Route
              path="/admin-defeitos"
              element={
                <ProtectedAdminRoute>
                  <AdminDefeitos />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
          <Routes>
            <Route path="/admin-embalagens" element={<ProtectedAdminRoute> <AdminEmbalagens /> </ProtectedAdminRoute>}  />
          </Routes>
          <Routes>
            <Route
              path="/admin-tipo-embalagens"
              element={<ProtectedAdminRoute> <AdminTipoEmbalagens /> </ProtectedAdminRoute>}
            />
          </Routes>
          <Routes>
            <Route path="/admin-carga-dados" element={<ProtectedAdminRoute><AdminCarga /></ProtectedAdminRoute>} />
          </Routes>
          <Routes>
            <Route path="/admin-acesso-painel-nce" element={
               <ProtectedAdminRoute><RelatoriosAcesso /></ProtectedAdminRoute>} />
          </Routes>
          <Routes>
            <Route path="/estratificacoes" element={<ErrorsNce />} />
          </Routes>
          <Routes>
            <Route path="/Nce" element={<Nce />} />
          </Routes>
          <Routes>
            <Route path="/comparativo" element={<ComparePage />} />
          </Routes>
          <Routes>
            <Route path="/analitico" element={<Analitico />} />
          </Routes>
          <Routes>
            <Route path="/mensal" element={<PQMFMensal />} />
          </Routes>
          <Routes>
            <Route path="/ranking" element={<RankingPage />} />
          </Routes>
        </div>
      </Menu>
    </BrowserRouter>
  );
};

export default RoutesConfig;
